var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "row" }, [
    _c("div", { staticClass: "col-12" }, [
      _c("div", { staticClass: "text-banner" }, [
        _c("div", { staticClass: "content-wrapper h-100 position-relative" }, [
          _c("img", {
            attrs: {
              src: _vm.story.acf.image.url,
              alt: _vm.story.title.rendered
            }
          }),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass:
                "content container h-100 d-flex justify-content-end flex-column"
            },
            [
              _c("h1", {
                staticClass: "text-white",
                domProps: { innerHTML: _vm._s(_vm.story.title.rendered) }
              }),
              _vm._v(" "),
              _c("div", { staticClass: "d-block mt-16" }, [
                _c("span", { staticClass: "text-white" }, [
                  _vm._v(_vm._s(_vm.story.acf.author))
                ]),
                _c("span", { staticClass: "text-white font-weight-light" }, [
                  _vm._v(" - " + _vm._s(_vm.story.acf.participants))
                ])
              ])
            ]
          )
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "share w-100 py-16 py-lg-0" }, [
        _c("div", { staticClass: "container" }, [
          _c(
            "div",
            { staticClass: "d-md-flex align-items-center d-lg-block" },
            [
              _c(
                "span",
                { staticClass: "text-white font-weight-bold mr-md-16 mr-lg-0" },
                [_vm._v("Deel deze story")]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "mt-8 mt-md-0 mt-lg-8 d-md-inline-block d-lg-block"
                },
                [
                  _c("a", {
                    staticClass: "linkedin mr-8",
                    attrs: {
                      target: "_blank",
                      href:
                        "https://www.linkedin.com/shareArticle?mini=true&url=" +
                        _vm.url +
                        "&title=" +
                        _vm.story.title.rendered
                    }
                  }),
                  _vm._v(" "),
                  _c("a", {
                    staticClass: "facebook mr-8",
                    attrs: {
                      target: "_blank",
                      href:
                        "https://www.facebook.com/sharer/sharer.php?u=" +
                        _vm.url
                    }
                  }),
                  _vm._v(" "),
                  _c("a", {
                    staticClass: "email mr-8",
                    attrs: {
                      href:
                        "mailto:?subject=" +
                        _vm.story.title.rendered +
                        " - ToffeTeambuildings.be&body=Lees hier de story: " +
                        _vm.url
                    }
                  }),
                  _vm._v(" "),
                  _c("a", {
                    staticClass: "whatsapp mr-8 mr-lg-0",
                    attrs: { href: "whatsapp://send?text=" + _vm.url }
                  }),
                  _vm._v(" "),
                  _c("a", {
                    staticClass: "messenger d-lg-none",
                    attrs: {
                      href:
                        "fb-messenger://share/?link=" +
                        _vm.url +
                        "&app_id=123456789"
                    }
                  })
                ]
              )
            ]
          )
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }